import type { FaireProductEntity } from "../../entity_types/product";

export const p_e6k3chh4qx: FaireProductEntity = {
  token: "p_e6k3chh4qx",
  type: "product",
  name: "Arkansas Razorbacks Embroideredred Red Stripes Polo Shirt",
  brandToken: "b_8jehdemzqt",
  brandName: "Vive La Fete",
  imageUrl:
    "https://cdn.faire.com/fastly/bba33992be047a6c37728a593007640c2eae883ce2ba026fb656d8c2559e1413.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/05413735ea81cf7433348749c9bddc81a5ce71a9f8abdc77bff30074bd5914a9.jpeg",
  ],
  priceDollars: 20.95,
  description:
    "Let your kiddo look cool in his new team spirit boy’s performance fabric Polo. Let him play, go to the game, and cheer loudly and proudly with his favorite team Licensed product sold by Vive La Fete.\n\nCelebrate and cheer on game day with our classic design favorite team Pencil Stripe Performance Polo with embroidered logo on the chest, moisture-wicking USA-made fabric, 3-button placket, and button on the back of the collar.\n\nThis pencil stripe Polo features officially licensed your favorite team color and chest embroidery; perfect to cheer for your favorite team.\n\nThis timeless design Polo is made with top-quality beautiful weave long-lasting moisture wicking soft knit 100% USA-made polyester fabric that holds its colors forever. Performance fabric that's comfy, strong, and breathable.\n\nCARE INSTRUCTIONS: Machine wash warm. Tumble dry low or hang dry. Remove promptly. Do not add fabric softeners. Do not iron. Do not bleach.",
  tags: [],
  msrpDollars: 41.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:41.881Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
